export const formatPrice = (price?: number) => {
  return Number(price || '0.00').toFixed(2);
};
